import React, {useState} from "react";
import {Container} from "react-grid-system";
import {Tab, TabBar, TabsProvider} from "../../components";
import {EstateTaxBreakdown, StrategyDetailsSectionInfo, StrategyType} from "../WealthPOTypes";
import StrategyContent from "./StrategyContent";
import EstateTaxBreakdownContent, {EstateTaxBreakdownReportContent} from "./EstateTaxBreakdownContent";
import {GTGTExemption} from "../../WealthTransfer/components/EstateTaxRunningTotal";
import {NO_OP} from "../../constants/common";

interface StrategyDetailsProps {
    refreshStrategiesSummary: () => void;
    strategyDetailsList: StrategyDetailsSectionInfo[];
    isContinued: boolean
    isInReportPreview: boolean;
    estateTaxBreakdownWithoutStrategies: EstateTaxBreakdown;
    estateTaxBreakdownWithStrategies: EstateTaxBreakdown;
    sorDescription?: string;
    gtgtExemptions?: GTGTExemption[];
    estateTaxBreakdownReportContent?: EstateTaxBreakdownReportContent
}

const StrategyDetailsSection: React.FC<StrategyDetailsProps> = ({
                                                                    refreshStrategiesSummary,
                                                                    strategyDetailsList,
                                                                    isContinued,
                                                                    isInReportPreview,
                                                                    estateTaxBreakdownWithoutStrategies,
                                                                    estateTaxBreakdownWithStrategies,
                                                                    sorDescription,
                                                                    gtgtExemptions,
                                                                    estateTaxBreakdownReportContent
                                                                }: StrategyDetailsProps) => {
    const [showStrategies, setShowStrategies] = useState(true);

    return (
        <section className={"strategy-summary-details-section"}>
            {!isInReportPreview &&
                (<Container className={"summary-details-tab"} data-testid="summary-details-tab">
                    <TabsProvider tabIdArray={["strategiesTab", "estimatedEstateTaxTab"]}>
                        <TabBar size="medium">
                            <Tab
                                name="Strategies"
                                onClick={() => {
                                    setShowStrategies(true);
                                }}
                            />
                            <Tab
                                name="Estimated Estate Tax"
                                onClick={() => {
                                    setShowStrategies(false);
                                }}
                            />
                        </TabBar>
                    </TabsProvider>
                    {showStrategies && <StrategyContent refreshStrategiesSummary={refreshStrategiesSummary}
                                                        strategyDetailsList={strategyDetailsList}
                                                        isContinued={false}
                                                        isInReportPreview={false}
                    />}
                    {!showStrategies &&
                        <EstateTaxBreakdownContent
                            estateTaxBreakdownWithoutStrategies={estateTaxBreakdownWithoutStrategies}
                            estateTaxBreakdownWithStrategies={estateTaxBreakdownWithStrategies}
                            strategyDetailsList={strategyDetailsList.filter(strategy => strategy.enabled
                                && strategy.type !== StrategyType.STATE_OF_RESIDENCY)}
                            sorDescription={sorDescription}
                            gtgtExemptions={gtgtExemptions}
                        />}
                </Container>)
            }

            {isInReportPreview && (<>
                {(strategyDetailsList.length > 0)
                    && <StrategyContent refreshStrategiesSummary={NO_OP}
                                        strategyDetailsList={strategyDetailsList}
                                        isContinued={isContinued}
                                        isInReportPreview={true}/>}
                {(strategyDetailsList.length === 0)
                    && (estateTaxBreakdownReportContent?.showStateTaxBreakdown || estateTaxBreakdownReportContent?.showFederalTaxBreakdown)
                    && <EstateTaxBreakdownContent
                        estateTaxBreakdownWithoutStrategies={estateTaxBreakdownWithoutStrategies}
                        estateTaxBreakdownWithStrategies={estateTaxBreakdownWithStrategies}
                        strategyDetailsList={strategyDetailsList.filter(strategy => strategy.enabled
                            && strategy.type !== StrategyType.STATE_OF_RESIDENCY)}
                        isInReportPreview={true}
                        estateTaxBreakdownReportContent={estateTaxBreakdownReportContent}
                    />}
            </>)}
        </section>
    );
}

export default StrategyDetailsSection;

